import { DetailSection, DetailField } from './content-box'
import { formatNameForDisplay } from 'lib/text-display'
import { formatPhoneNumberForDisplay } from 'utils/phoneNumber'
import PersonOutlineIcon from 'components/material-symbol/icons/PersonOutline'
import LocalPhoneOutlinedIcon from 'components/material-symbol/icons/LocalPhone'
import { useSnackbar } from 'notistack'
import { useSnackbarSuccess } from 'lib/snackbar'

export default function EmergencyInformation({
  emergencyContact,
  medicalProfile,
}) {
  const { enqueueSnackbar } = useSnackbar()
  const snackbarSuccess = useSnackbarSuccess(enqueueSnackbar)

  const copyToClipboard = async (event, text) => {
    event.stopPropagation()
    navigator.clipboard.writeText(text)
    snackbarSuccess('Successfully copied to clipboard.')
  }

  if (!emergencyContact && !medicalProfile) return null

  const emergencyContactName = emergencyContact
    ? formatNameForDisplay(
      `${emergencyContact.firstName} ${emergencyContact.lastName}`,
    )
    : 'N/A'
  const doctorName = medicalProfile?.primaryDoctor
    ? `Dr. ${formatNameForDisplay(medicalProfile.primaryDoctor)}`
    : 'N/A'
  const emergencyPhone =
    formatPhoneNumberForDisplay(emergencyContact?.phone) || 'N/A'
  const doctorPhone =
    formatPhoneNumberForDisplay(medicalProfile?.primaryDoctorPhone) || 'N/A'

  return (
    <DetailSection title="Emergency information">
      <DetailField
        icon={PersonOutlineIcon}
        label="Emergency Contact"
        value={emergencyContactName}
        testId="emergency-name"
      />
      <DetailField
        icon={LocalPhoneOutlinedIcon}
        label="Emergency Phone"
        value={emergencyPhone}
        href={
          emergencyContact?.phone ? `tel:${emergencyContact.phone}` : undefined
        }
        onCopy={
          emergencyContact?.phone
            ? event => copyToClipboard(event, emergencyContact.phone)
            : undefined
        }
        testId="emergency-phone"
      />
      <DetailField
        icon={PersonOutlineIcon}
        label="Doctor"
        value={doctorName}
        testId="doctor-name"
      />
      <DetailField
        icon={LocalPhoneOutlinedIcon}
        label="Doctor Phone"
        value={doctorPhone}
        href={
          medicalProfile?.primaryDoctorPhone
            ? `tel:${medicalProfile.primaryDoctorPhone}`
            : undefined
        }
        onCopy={
          medicalProfile?.primaryDoctorPhone
            ? event => copyToClipboard(event, medicalProfile.primaryDoctorPhone)
            : undefined
        }
        testId="doctor-phone"
      />
    </DetailSection>
  )
}
